import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default, { Children, useReducer, useCallback, useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './Dropdown.module.css.js';
import { reducer, initialiseReducer, actions } from './reducer.js';
import '../../Layout/Box/Box.js';
import '../../Layout/Inline/Inline.js';
import { Stack } from '../../Layout/Stack/Stack.js';
import '../../Atoms/Button/Button.js';
import '../../Atoms/Checkbox/Checkbox.js';
import '../../Atoms/Text/Text.js';
import '../../Atoms/Device/DeviceProvider.js';
import '../../Atoms/EmployeeBadge/EmployeeBadge.js';
import '../../Atoms/FeatureFlag/FeatureFlag.js';
import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import 'fromentries';
import '../../Atoms/Icon/generated/IconAdd.js';
import '../../Atoms/Icon/generated/IconAddFilled.js';
import '../../Atoms/Icon/generated/IconAddOutline.js';
import '../../Atoms/Icon/generated/IconAddUser.js';
import '../../Atoms/Icon/generated/IconAddressBook.js';
import '../../Atoms/Icon/generated/IconAllTreatments.js';
import '../../Atoms/Icon/generated/IconArrowBack.js';
import '../../Atoms/Icon/generated/IconArrowForward.js';
import '../../Atoms/Icon/generated/IconBadgeCheck.js';
import '../../Atoms/Icon/generated/IconBeard.js';
import '../../Atoms/Icon/generated/IconBody.js';
import '../../Atoms/Icon/generated/IconCake.js';
import '../../Atoms/Icon/generated/IconCalendar.js';
import '../../Atoms/Icon/generated/IconCalendarAdd.js';
import '../../Atoms/Icon/generated/IconCalendarDelete.js';
import '../../Atoms/Icon/generated/IconCard.js';
import '../../Atoms/Icon/generated/IconCash.js';
import '../../Atoms/Icon/generated/IconCaution.js';
import '../../Atoms/Icon/generated/IconChat.js';
import '../../Atoms/Icon/generated/IconCheckFilled.js';
import '../../Atoms/Icon/generated/IconCheckOutline.js';
import '../../Atoms/Icon/generated/IconChecked.js';
import { IconChevronDown } from '../../Atoms/Icon/generated/IconChevronDown.js';
import '../../Atoms/Icon/generated/IconChevronLeft.js';
import '../../Atoms/Icon/generated/IconChevronLeftOutline.js';
import '../../Atoms/Icon/generated/IconChevronRight.js';
import '../../Atoms/Icon/generated/IconChevronRightOutline.js';
import { IconChevronUp } from '../../Atoms/Icon/generated/IconChevronUp.js';
import '../../Atoms/Icon/generated/IconClose.js';
import '../../Atoms/Icon/generated/IconCloseOutline.js';
import '../../Atoms/Icon/generated/IconComment.js';
import '../../Atoms/Icon/generated/IconCompass.js';
import '../../Atoms/Icon/generated/IconConfirmOrDeny.js';
import '../../Atoms/Icon/generated/IconCopy.js';
import '../../Atoms/Icon/generated/IconDiscountFilled.js';
import '../../Atoms/Icon/generated/IconDiscountOutline.js';
import '../../Atoms/Icon/generated/IconEdit.js';
import '../../Atoms/Icon/generated/IconEmail.js';
import '../../Atoms/Icon/generated/IconExpand.js';
import '../../Atoms/Icon/generated/IconExternal.js';
import '../../Atoms/Icon/generated/IconFace.js';
import '../../Atoms/Icon/generated/IconFilter.js';
import '../../Atoms/Icon/generated/IconGift.js';
import '../../Atoms/Icon/generated/IconHair.js';
import '../../Atoms/Icon/generated/IconHairRemoval.js';
import '../../Atoms/Icon/generated/IconHappy.js';
import '../../Atoms/Icon/generated/IconHeartFilled.js';
import '../../Atoms/Icon/generated/IconHeartOutlined.js';
import '../../Atoms/Icon/generated/IconHelp.js';
import '../../Atoms/Icon/generated/IconHide.js';
import '../../Atoms/Icon/generated/IconHighlights.js';
import '../../Atoms/Icon/generated/IconHome.js';
import '../../Atoms/Icon/generated/IconHomebasedVenue.js';
import '../../Atoms/Icon/generated/IconImage.js';
import '../../Atoms/Icon/generated/IconInfoOutline.js';
import '../../Atoms/Icon/generated/IconLegal.js';
import '../../Atoms/Icon/generated/IconLocation.js';
import '../../Atoms/Icon/generated/IconLock.js';
import '../../Atoms/Icon/generated/IconLogOut.js';
import '../../Atoms/Icon/generated/IconMale.js';
import '../../Atoms/Icon/generated/IconMassage.js';
import '../../Atoms/Icon/generated/IconMedicalDental.js';
import '../../Atoms/Icon/generated/IconMinusOutline.js';
import '../../Atoms/Icon/generated/IconMobileVenue.js';
import '../../Atoms/Icon/generated/IconMoney.js';
import '../../Atoms/Icon/generated/IconNails.js';
import '../../Atoms/Icon/generated/IconNewVenue.js';
import '../../Atoms/Icon/generated/IconNotes.js';
import '../../Atoms/Icon/generated/IconOnMap.js';
import '../../Atoms/Icon/generated/IconOptions.js';
import '../../Atoms/Icon/generated/IconPhone.js';
import '../../Atoms/Icon/generated/IconPin.js';
import '../../Atoms/Icon/generated/IconPinOutline.js';
import '../../Atoms/Icon/generated/IconPresentBox.js';
import '../../Atoms/Icon/generated/IconProfile.js';
import '../../Atoms/Icon/generated/IconReceipt.js';
import '../../Atoms/Icon/generated/IconSearch.js';
import '../../Atoms/Icon/generated/IconSecure.js';
import '../../Atoms/Icon/generated/IconSettings.js';
import '../../Atoms/Icon/generated/IconSort.js';
import '../../Atoms/Icon/generated/IconSpa.js';
import '../../Atoms/Icon/generated/IconStarFilled.js';
import '../../Atoms/Icon/generated/IconStarOutline.js';
import '../../Atoms/Icon/generated/IconSupport.js';
import '../../Atoms/Icon/generated/IconTeam.js';
import '../../Atoms/Icon/generated/IconTime.js';
import '../../Atoms/Icon/generated/IconTreatwellLogo.js';
import '../../Atoms/Icon/generated/IconUnisex.js';
import '../../Atoms/Icon/generated/IconUser.js';
import '../../Atoms/Icon/generated/IconUserDetails.js';
import '../../Atoms/Icon/generated/IconVenue.js';
import '../../Atoms/Icon/generated/IconView.js';
import '../../Atoms/Icon/generated/IconVoucher.js';
import '../../Atoms/Icon/generated/IconWallet.js';
import '../../Atoms/Icon/generated/IconWarningFilled.js';
import '../../Atoms/Icon/generated/IconWarningOutline.js';
import '../../Atoms/Icon/generated/IconWebsite.js';
import '../../Atoms/IconBadge/IconBadge.js';
import '../../Atoms/Input/Input.js';
import '../../Atoms/Radio/Radio.js';
import '@treatwell/design-tokens';
import '../../Atoms/VisuallyHidden/VisuallyHidden.js';
import '../../Atoms/Textarea/Textarea.js';
import '../../Atoms/TreatmentTypeBadge/TreatmentTypeBadge.js';
import '../../Atoms/Viewport/useViewport.js';
import '../../Atoms/LinkButton/LinkButton.js';
import { useKeyPress } from '../../../hooks/useKeyPress/useKeyPress.js';
import { useClickOutside } from '../../../hooks/useClickOutside/useClickOutside.js';

const Dropdown = ({ children, labelId, disabled, initialSelected, enableScroll, onSelected, space, onToggle, menuWidthAuto, menuStyle, isInitialOpen, caretSize = 24, }) => {
    const elementArray = Children.toArray(children);
    const initialState = {
        elementArray,
        initialSelected,
        isOpen: isInitialOpen || false,
    };
    const [state, dispatch] = useReducer(reducer, initialState, initialiseReducer);
    const { selectedElement, index: selectedIndex, isOpen: isDropdownOpen } = state;
    const handleArrowPress = useCallback((event) => {
        if (isDropdownOpen) {
            event.preventDefault();
        }
    }, [isDropdownOpen]);
    const isDownKeyPressed = useKeyPress({
        key: 'ArrowDown',
        onPress: handleArrowPress,
    });
    const isUpKeyPressed = useKeyPress({
        key: 'ArrowUp',
        onPress: handleArrowPress,
    });
    const isEnterKeyPressed = useKeyPress({ key: 'Enter' });
    const isEscapeKeyPressed = useKeyPress({ key: 'Escape' });
    const isTabKeyPressed = useKeyPress({ key: 'Tab' });
    const Caret = isDropdownOpen ? IconChevronUp : IconChevronDown;
    useEffect(() => {
        dispatch({
            type: actions.refresh,
            payload: { value: initialSelected, children: elementArray },
        });
    }, [initialSelected]);
    useEffect(() => {
        dispatch({
            type: actions.refresh,
            payload: { children: elementArray, value: initialSelected },
        });
    }, [elementArray.length, initialSelected]);
    const indexOfSelected = elementArray.findIndex((item) => {
        return item.props.value === selectedElement.props.value;
    });
    useEffect(() => {
        if (indexOfSelected === -1) {
            dispatch({ type: actions.setIndex, payload: { index: 0 } });
            return;
        }
        dispatch({ type: actions.setIndex, payload: { index: indexOfSelected } });
    }, [indexOfSelected]);
    const buttonRef = React__default.useRef(null);
    const menuRef = React__default.useRef(null);
    const highlightedRowRef = React__default.useRef(null);
    const handleClickOutside = useCallback((event) => {
        var _a;
        if (event.target && ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            return;
        }
        if (isDropdownOpen) {
            dispatch({ type: actions.toggleVisibility, payload: { isOpen: false } });
            dispatch({ type: actions.setIndex, payload: { index: indexOfSelected } });
        }
    }, [indexOfSelected, isDropdownOpen]);
    useClickOutside({ ref: menuRef, handler: handleClickOutside });
    useEffect(() => {
        if (isDownKeyPressed && isDropdownOpen) {
            dispatch({ type: actions.decrementIndex });
        }
    }, [isDownKeyPressed, isDropdownOpen]);
    useEffect(() => {
        if (isUpKeyPressed && isDropdownOpen) {
            dispatch({ type: actions.incrementIndex });
        }
    }, [isUpKeyPressed, isDropdownOpen]);
    useEffect(() => {
        if (isDropdownOpen && highlightedRowRef.current) {
            highlightedRowRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }
    }, [selectedIndex, isDropdownOpen]);
    useEffect(() => {
        const hasSelectedElementChanged = elementArray[selectedIndex].props.value !== selectedElement.props.value;
        if (isEnterKeyPressed && isDropdownOpen && hasSelectedElementChanged) {
            dispatch({
                type: actions.setElement,
                payload: { element: elementArray[selectedIndex], index: selectedIndex },
            });
            onSelected === null || onSelected === void 0 ? void 0 : onSelected(elementArray[selectedIndex].props.value);
        }
    }, [selectedIndex, isEnterKeyPressed, isDropdownOpen]);
    useEffect(() => {
        if (isEscapeKeyPressed && isDropdownOpen) {
            dispatch({ type: actions.toggleVisibility, payload: { isOpen: false } });
            dispatch({ type: actions.setIndex, payload: { index: indexOfSelected } });
        }
    }, [isEscapeKeyPressed, isDropdownOpen, indexOfSelected]);
    useEffect(() => {
        if (isTabKeyPressed && isDropdownOpen) {
            dispatch({ type: actions.toggleVisibility, payload: { isOpen: false } });
            dispatch({ type: actions.setIndex, payload: { index: indexOfSelected } });
        }
    }, [isTabKeyPressed, isDropdownOpen, indexOfSelected]);
    const dropdownId = useRef(`dropdownId-${labelId}`).current;
    const handleButtonClick = () => {
        if (disabled) {
            return;
        }
        dispatch({
            type: actions.toggleVisibility,
            payload: { isOpen: !isDropdownOpen },
        });
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!isDropdownOpen);
    };
    return (jsxRuntimeExports.jsxs("div", { className: styles.root, children: [jsxRuntimeExports.jsxs("button", { type: "button", id: dropdownId, ref: (node) => {
                    if (!node) {
                        return;
                    }
                    buttonRef.current = node;
                    if (isDropdownOpen && document.activeElement !== node) {
                        node.focus();
                    }
                }, disabled: disabled, "aria-labelledby": `${labelId} ${dropdownId}`, "aria-expanded": isDropdownOpen, "aria-haspopup": "listbox", className: clsx(styles.button, {
                    [styles.isOpen]: isDropdownOpen,
                }), onClick: handleButtonClick, children: [React__default.cloneElement(selectedElement, {
                        isSelected: true,
                        isHighlighted: false,
                        isDropdownOption: false,
                        children: React__default.cloneElement(selectedElement.props.children, {
                            isSelected: true,
                            isHighlighted: false,
                            isDropdownOption: false,
                            isDropdownOpen,
                        }),
                    }), jsxRuntimeExports.jsx(Caret, { className: styles.caret, size: caretSize })] }), jsxRuntimeExports.jsx("div", { className: clsx(styles.menu, {
                    [styles.maxHeight]: enableScroll,
                    [styles.autoWidth]: menuWidthAuto,
                }), style: menuStyle, hidden: !isDropdownOpen, role: "listbox", ref: menuRef, "aria-activedescendant": `${dropdownId}-${selectedElement.props.value.toLowerCase()}`, "aria-labelledby": labelId, children: jsxRuntimeExports.jsx(Stack, { space: space, children: elementArray.map((dropdownItem, index) => {
                        const { children: dropdownItemChildren } = dropdownItem.props;
                        if (typeof elementArray[selectedIndex] === 'undefined') {
                            return;
                        }
                        const isHighlighted = elementArray[selectedIndex].props.value ===
                            dropdownItem.props.value;
                        const isSelected = dropdownItem.props.value === selectedElement.props.value;
                        const isDropdownOption = true;
                        return React__default.cloneElement(dropdownItem, {
                            onClick: (event) => {
                                event.preventDefault();
                                onSelected === null || onSelected === void 0 ? void 0 : onSelected(dropdownItem.props.value);
                                if (dropdownItem.props.value !== selectedElement.props.value) {
                                    dispatch({
                                        type: actions.setElement,
                                        payload: {
                                            element: dropdownItem,
                                            index,
                                        },
                                    });
                                }
                                dispatch({
                                    type: actions.toggleVisibility,
                                    payload: { isOpen: false },
                                });
                            },
                            isSelected,
                            isHighlighted,
                            isDropdownOption,
                            id: `${dropdownId}-${dropdownItem.props.value.toLowerCase()}`,
                            ref: isHighlighted ? highlightedRowRef : null,
                            children: React__default.cloneElement(dropdownItemChildren, {
                                isHighlighted,
                                isSelected,
                                isDropdownOption,
                                isDropdownOpen,
                            }),
                        });
                    }) }) })] }));
};
const DropdownItem = React__default.forwardRef(({ children, onClick, id, className, isSelected, isDropdownOption, isHighlighted, }, ref) => {
    const props = {
        className: clsx(styles.item, className, {
            [styles.highlight]: isHighlighted,
            [styles.dropdownOption]: isDropdownOption,
        }),
        onClick,
        children,
        id,
        'aria-selected': isSelected && isDropdownOption,
        role: 'option',
    };
    if (isSelected && !isDropdownOption) {
        delete props['aria-selected'];
        delete props.role;
        delete props.id;
    }
    return (jsxRuntimeExports.jsx("div", { ...props, ref: ref, children: children }));
});
DropdownItem.displayName = 'DropdownItem';

export { Dropdown, DropdownItem };
//# sourceMappingURL=Dropdown.js.map
